
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import { getPathsFromContext, getResourceByPath } from "next-drupal";
import Layout from "components/Layout";
import { DrupalJsonApiParams } from "drupal-jsonapi-params";
import getCrumbs from "lib/getCrumbs";
import { getGlobals } from "lib/getGlobals";
import Header from "components/Header";
import fixPathsSlug from "lib/fixPathsSlug";
import Meta from "components/Meta";
import NodeGalleryContent from "components/Gallery/NodeGalleryContent";
import { getPathFromContext } from "lib/i18n";

export default function GallerySlugPage({ globals, crumbs, node }) {
  if (!node) return null;

  return (
    <Layout globals={globals}>
      <Meta
        title={node.field_meta_title || node.title}
        description={node.field_meta_description || null}
      />
      <Header
        crumbs={crumbs}
        title={node.title}
        notTranslated={node.field_not_translated}
      />

      <section className="relative pt-10 pb-20">
        <div
          className="absolute top-0 inset-x-0 h-32 bg-secondary-dark"
          aria-hidden="true"
        />

        <div className="relative container mx-auto px-4">
          <NodeGalleryContent node={node} />
        </div>
      </section>
    </Layout>
  );
}

export async function getStaticPaths(context) {
  const drupalPaths = await getPathsFromContext("node--gallery", context);

  return {
    paths: fixPathsSlug(drupalPaths),
    fallback: true,
  };
}

 async function _getStaticProps(context) {
  const globals = await getGlobals(context);
  const path = getPathFromContext(context, "node--gallery");
  const params = new DrupalJsonApiParams();

  const node = await getResourceByPath(`${path}/${context.params.slug}`, {
    params: params.addInclude(["field_images"]).getQueryObject(),
    locale: context.locale,
    defaultLocale: context.defaultLocale,
  });

  if (!context.preview && !node?.status) {
    return {
      notFound: true,
      revalidate: 30,
    };
  }

  return {
    props: {
      crumbs: getCrumbs(context, node, globals.menus.crumbsFallback),
      globals,
      node,
    },
    revalidate: 30,
  };
}


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/node--gallery/[slug]',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  